import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

/**
 * Một khối nội dung trong trang: tiêu đề nhỏ + (một) hành động + nội dung.
 *
 * Nổi lên khỏi nền bằng một bóng mềm (không kèm viền — một lớp độ sâu là
 * đủ), và không bao giờ lồng Section trong Section. Cũng không có prop mô tả: nếu
 * tiêu đề khối cần một câu giải thích thì tiêu đề đó chưa đúng.
 */
export function Section({
  title,
  action,
  children,
  bare = false,
  className,
}: {
  title?: ReactNode
  action?: ReactNode
  children: ReactNode
  /** Bỏ viền và nền — khi khối đã nằm trong một bề mặt khác. */
  bare?: boolean
  className?: string
}) {
  return (
    <section
      data-slot={bare ? undefined : 'section'}
      className={cn(!bare && 'rounded-xl bg-raise shadow-card dark:border dark:border-rule dark:shadow-none', className)}
    >
      {(title || action) && (
        <div
          className={cn(
            'flex items-center justify-between gap-3',
            bare ? 'pb-3' : 'border-b border-rule px-4 py-3',
          )}
        >
          {title && <h2 className="min-w-0 truncate">{title}</h2>}
          {action && <div className="shrink-0">{action}</div>}
        </div>
      )}
      {children}
    </section>
  )
}
